import './App.css';
import { Route, Routes, Navigate } from "react-router-dom";

import NotFound from "components/pages/404/404";

import KakaoRegistration from "components/pages/onboardingNew/PayDescription/Mobile/kakaoRegistration";
import PaypleRegistration from "components/pages/onboardingNew/PayDescription/Mobile/paypleRegistration";

import Login from "components/pages/onboardingNew/login/login";
import KakaoLogin from "components/pages/onboardingNew/login/Mobile/KakaoLogin";

// // new homepage
import Landing39 from "components/pages/homePage/landing";
// import Subscribe from "components/pages/homePage/Mobile/subscribe/subscribe";
import LandingApp from "components/pages/homePage/Mobile/app/landingApp";
import Product from "components/pages/homePage/Mobile/product/product";

import SelectFreePhoto from "components/pages/onboardingNew/SelectFreePhoto/SelectFreePhoto";
import InputUserDetail  from "components/pages/onboardingNew/InputUserDetail/InputUserDetail";
import SelectCreditType from "components/pages/onboardingNew/PayDescription/PayDescription";
import SubscriptionComplete from "components/pages/onboardingNew/SubscriptionComplete/SubscriptionComplete";

//klikkie
import KlikkieMain from "components/pages/klikkie/homePage/landing";
import Subscribe from "components/pages/klikkie/homePage/Mobile/subscribe/subscribe"
import KlikkieApp from "components/pages/klikkie/homePage/Mobile/app/landingApp";
import KlikkieProduct from "components/pages/klikkie/homePage/Mobile/product/product";
import KlikkieEvent from "components/pages/klikkie/homePage/Mobile/event/free";
// import Plan        from "components/pages/klikkie/homePage/Mobile/plan/plan";
// import SubsDetail from 'components/pages/klikkie/homePage/Mobile/subsDetail/subsDetail';


import ReactGA from'react-ga4';
import ReactPixel from 'react-facebook-pixel';import Free from 'components/pages/homePage/Mobile/event/free';
// import Album from "components/pages/klikkie/homePage/Mobile/album/album";
// import KlikkiePhoto from 'components/pages/klikkie/homePage/Mobile/photo/photo';
// import Gift from 'components/pages/klikkie/homePage/Mobile/gift/gift';
// import Scrap from 'components/pages/klikkie/homePage/Mobile/scrap/scrap';
// import Howto from 'components/pages/klikkie/homePage/Mobile/how/how';
// import BabyGift from 'components/pages/klikkie/homePage/Mobile/babyGift/gift';

// import Millie from 'components/pages/millie/homePage/Mobile/main/millie';

const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || '';
const pixelId = process.env.REACT_APP_PIXEL_ID || ''

ReactGA.initialize([
  {
    trackingId: gaId,
    gaOptions: {
      debug_mode: true,
    },
    gtagOptions: {
      debug_mode: true
    }
}]);

  const options = {
    autoConfig: true,
    debug: true,
  };

ReactPixel.init(pixelId, undefined, options);
// ReactPixel.init(pixelId);

declare global {
  interface Window { 
    Kakao: any;
    // wcs? : {
    //   inflow: () => void;
    //   wcs_do: (params?: Record<string, any>) => void;
    // }
  }
}

function App() {
  const loginStatus =localStorage.getItem("token3") ? "LOGGED_IN" : null;
  if (loginStatus === "LOGGED_IN") {
    return <AuthorizedView />
  }
  return <UnAuthorizedView />
};

const UnAuthorizedView = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<KlikkieMain />}/>
        <Route path="/plan" element={< Subscribe/>}/>
        {/* <Route path="/subscribe" element={<KlikkieSubs />}/> */}
        <Route path="/print" element={<KlikkieApp />}/>
        <Route path="/product" element={<KlikkieProduct />}/>
        <Route path="/free" element={<Free/>}/>
        <Route path="/login" element={<Login />}/>
        <Route path="/event" element={<KlikkieEvent/>}/>
        <Route path="/kakaoLogin" element={<KakaoLogin />}/>
        {/* <Route path="/plan" element={<Plan />}/> */}
        <Route path="*" element={<Navigate to="/"/>} />        
        {/* <Route path="/klikkie/homepage" element={<KlikkieMain/>}/>
        <Route path="/klikkie/subs" element={<KlikkieSubs/>}/>
        <Route path="/klikkie/subs/plan" element={<SubsDetail />}/>
        <Route path="/klikkie/app" element={<KlikkieApp/>}/>
        <Route path="/klikkie/product" element={<KlikkieProduct/>}/>
        <Route path="/klikkie/album" element={<Album />}/>
        <Route path="/klikkie/photo" element={<KlikkiePhoto />}/>
        <Route path="/klikkie/gift" element={<Gift />}/>
        <Route path="/klikkie/scrap" element={<Scrap />}/>
        <Route path="/klikkie/howto" element={<Howto />}/>
        <Route path="/klikkie/baby/gift" element={<BabyGift />}/> */}
        {/* <Route path="/" element={<Millie />}/> */}
        {/* <Route path="/" element={<KlikkieMain />}/> */}
      </Routes>
    </>
  )
};

const AuthorizedView = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing39 />}/>
        <Route path="/subscribe" element={<Subscribe />}/>
        <Route path="/app" element={<LandingApp />}/>
        <Route path="/product" element={<Product />}/>
        
        <Route path="/404" element={< NotFound/>} />
        <Route path="/" element={<Navigate to="/"/>} />
        <Route path="/onboarding/1/freekit" element={<SelectFreePhoto />}/>
        <Route path="/onboarding/2/detail" element={<InputUserDetail />}/>
        <Route path="/onboarding/3/credit" element={<SelectCreditType />}/>
        <Route path="/onboarding/4/complete" element={<SubscriptionComplete />}/>
        <Route path="/registration/kakao" element={<KakaoRegistration />}/>
        <Route path="/registration/payple" element={<PaypleRegistration />}/>
        <Route path="*" element={<Navigate to="/404" />}/>
      </Routes>
    </>
  )
};

export default App;
